import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0eef2fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center my-2"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "py-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center my-2" }, " Ei ole planeeritud kohtumisi ega tegevusi. ")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "py-4 ikooniVeerg" }
const _hoisted_6 = { class: "py-4 pealkiriVeerg" }
const _hoisted_7 = {
  key: 0,
  class: "font-weight-bold text-no-wrap"
}
const _hoisted_8 = {
  key: 1,
  class: "font-weight-bold text-no-wrap text-capitalize-first-letter"
}
const _hoisted_9 = { class: "text-medium-emphasis" }
const _hoisted_10 = {
  key: 2,
  class: "text-medium-emphasis"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Koht: ", -1))
const _hoisted_12 = { class: "py-4" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "nuppudeVeerg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_v_progress_circular, { indeterminate: "" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_v_table, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("tbody", null, [
                  (!_ctx.tegevused || _ctx.tegevused.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_2, _hoisted_4))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tegevused, (tegevus) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: tegevus.id
                    }, [
                      _createElementVNode("td", _hoisted_5, [
                        _createVNode(_component_v_avatar, {
                          class: "rounded mt-4",
                          rounded: "0",
                          color: _ctx.ikooniVarv(tegevus.liik)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "x-large",
                              color: "var(--varv-icon-4)",
                              icon: _ctx.ikoon(tegevus.liik)
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ]),
                      _createElementVNode("td", _hoisted_6, [
                        (tegevus.liik === _ctx.tegevuseLiigid.HoiveProgramm)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(tegevus.pealkiri), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(tegevus.pealkiri), 1)),
                        _createElementVNode("p", _hoisted_9, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.tegevuseAjaPealkiri(tegevus.liik)) + ": ", 1),
                          _createTextVNode(_toDisplayString(_ctx.tegevuseAegFormateeritud(tegevus.liik, tegevus.algusKp, tegevus.loppKp)), 1)
                        ]),
                        (tegevus.koht)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                              _hoisted_11,
                              _createTextVNode(_toDisplayString(tegevus.koht), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_12, [
                        (tegevus.selgitused && tegevus.selgitused.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("p", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.selgitusePealkiri(tegevus.liik)), 1)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tegevus.selgitused, (selgitus, index) => {
                                return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(selgitus), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_14, [
                        (tegevus.liik === _ctx.tegevuseLiigid.ÜldkasulikTöö)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              color: "primary",
                              elevation: "3",
                              variant: "plain",
                              to: { name: 'uldkasulik_Too', params: { ajakavaRidaId: tegevus.lisand?.split('|') } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Näita ajakava "),
                                _createVNode(_component_v_icon, { icon: "mdi-arrow-right" })
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true),
                        (tegevus.liik === _ctx.tegevuseLiigid.ElektroonilineValve)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              color: "primary",
                              elevation: "3",
                              variant: "plain",
                              to: { name: 'elektrooniline_valve', params: { ajakavaRidaId: tegevus.lisand } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Näita ajakava "),
                                _createVNode(_component_v_icon, { icon: "mdi-arrow-right" })
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true),
                        (tegevus.liik === _ctx.tegevuseLiigid.ElektroonilineValveKinnitamata)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 2,
                              color: "primary",
                              elevation: "3",
                              variant: "plain",
                              to: { name: 'elektrooniline_valve', params: { ajakavaRidaId: tegevus.id } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Näita ajakava "),
                                _createVNode(_component_v_icon, { icon: "mdi-arrow-right" })
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}